/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Tab_ReviewInputs */

const cs_gdpr_tab_review = /** @type {(inputs: Gdpr_Tab_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrola uchování`)
};

const en_gdpr_tab_review = /** @type {(inputs: Gdpr_Tab_ReviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retention review`)
};

/**
* | output |
* | --- |
* | "Retention review" |
*
* @param {Gdpr_Tab_ReviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_tab_review = /** @type {((inputs?: Gdpr_Tab_ReviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Tab_ReviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_tab_review(inputs)
	return cs_gdpr_tab_review(inputs)
});